import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './stepper.module.css';

const Stepper = ({ steps, activeStep = 0 }) => (
    <Box className={styles.stepper}>
        {steps.map((label, index) => (
            <Box key={label} className={styles.step}>
                {index > 0 && <Box className={styles.connector} />}
                <Box className={clsx(styles.dot, index === activeStep && styles.dotActive)} />
                <Typography
                    className={clsx(styles.label, index === activeStep && styles.labelActive)}
                >
                    {label}
                </Typography>
            </Box>
        ))}
    </Box>
);

Stepper.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    activeStep: PropTypes.number,
};

export default Stepper;
